import { render } from "./ValidationRules.vue?vue&type=template&id=24e597c6"
import script from "./ValidationRules.vue?vue&type=script&lang=js"
export * from "./ValidationRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__